<template>
	<div class="sidebar-box-head">
		<h3>
		<i class="icon icon-file"></i>

			Files ({{ sortedFiles.length }})

		</h3>

		<div class="sidebar-box-head__actions">
			<a
				type="button"
				class="btn--expand-widget"
				@click="enableFilesVisibility"
				v-if="sortedFiles.length && !isExpanded"
				>
				Expand
			</a>
		</div>
	</div>

	<div
		class="widget-files"
		v-bind:class="{ 'widget-files--expanded': isExpanded }"
	>
		<div class="widget__head">
			<div class="widget__head-column widget__head-column--large">
				<search @search-change="onSearch" />
			</div>

			<div class="widget__head-column widget__head-column--small">
				<div class="select">
					<select class="select__field field" v-model="sortBy">
						<option value="size">Size</option>
						<option value="date">Date</option>
						<option value="name">Name</option>
					</select>
				</div>
			</div>
		</div>

		<files-table :files="sortedFiles" v-if="sortedFiles.length"/>

		<div class="widget__noresults" v-else>
			<p v-if="searchQuery.length > 0">Sorry, there are no results that match your search</p>
			<p v-else>No attachments in this thread</p>
		</div>
	</div>
</template>

<script>
/**
 * The internal dependencies.
 */
import FilesTable from '@components/Files/Table.vue';
import Search from '@components/Files/Search.vue';

const createDateComparator = (sortOrder) => (file1, file2) => {
	return 1;
};

const createSizeComparator = (sortOrder) => (file1, file2) => {
	const { size: size1 } = file1;
	const { size: size2 } = file2;

	return size2 - size1;
};

const createNameComparator = (sortOrder) => (file1, file2) => {
	const { original_name: name1 } = file1;
	const { original_name: name2 } = file2;

	if ( name1 < name2 ) {
		return -1;
	}

	if ( name1 > name2 ) {
		return 1;
	}

	return 0;
};

export default {
	name: 'files-widget',

	components: {
		FilesTable,
		Search,
	},

	data() {
		return {
			files: window.$$files || [],
			searchQuery: '',
			sortBy: 'size',
			sortOrder: 'DSC',
			isExpanded: false,
		};
	},

	methods: {
		onSearch(searchQuery) {
			this.searchQuery = searchQuery;
		},
		enableFilesVisibility() {
			this.isExpanded = true;
		}
	},

	computed: {
		filteredFiles() {
			if (!this.searchQuery.length) {
				return this.files;
			}

			return this.files.filter(file => {
				const name = file.original_name.toLowerCase();

				return name.includes(this.searchQuery.toLowerCase());
			});
		},

		sortedFiles() {
			if (!this.sortBy) {
				return this.filteredFiles;
			}

			let comparator;

			switch(this.sortBy) {
				case 'name':
					comparator = createNameComparator(this.sortOrder);
					break;

				case 'size':
					comparator = createSizeComparator(this.sortOrder);
					break;

				case 'date':
				default:
					comparator = createDateComparator(this.sortOrder);
					break;
			}

			return this.filteredFiles.slice().sort(comparator);
		},
	},
};
</script>

<style scoped>
	/*  Widget Files  */

	.widget-files { overflow: hidden; max-height: 0; width: 100%; transition: max-height .4s; }
	.widget-files--expanded { overflow: auto; max-height: 999px; }

	.widget-files .widget__head {
		display: flex;
		margin-top: -8px;
		margin-left: -8px;
		margin-bottom: 8px;
	 }

	.widget-files .widget__head-column {
		padding-top: 8px;
		padding-left: 8px;
	}
	.widget-files .widget__head-column--small {
		width: 30%;
		flex: 0 0 30%;
	}
	.widget-files .widget__head-column--large {
		width: 70%;
		flex: 0 0 70%;
	}

	.widget-files .widget__noresults { padding-top: 5px; }
	.widget-files .widget__noresults p { font-size: 13px; text-align: center; }
</style>
